export enum ActionTypes {
 UPDATE_TAG = '[UPDATE_TAG] Update tag',
 UPDATE_TAG_SUCCESS = '[UPDATE_TAG_SUCCESS] Update tag success',
 UPDATE_TAG_FAILURE = '[UPDATE_TAG_FAILURE] Update tag failure',
}
